String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};
var VM = function () {
    var self = this;

    self.validate = function () {
        document.querySelector('.loading-validator').classList.add('d-block');
        self.webconfig(escapeHtml(self.input()));

        const form = document.getElementById('validateMe');
        const formData = new FormData(form);
        theData = new URLSearchParams(formData).toString();

        fetch("/tools/webconfigtransformationtesterresult/", {
            method: 'POST',
            headers: {
                '__RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value'),
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: theData
        })
        .then(response => {
            if (!response.ok) {
                return response.text().then(errorMessage => {
                    throw new Error(errorMessage);
                });
            }
            return response.text();
        })
        .then(response => {
            const content = response;
            if (content) {
                // do something
                self.content(escapeHtml(content));
                self.error("");
                self.showResult(true);
                diffUsingJS(self.input(), content);
            }
            // Hljs
            document.querySelectorAll('pre code').forEach((block) => {
                hljs.highlightBlock(block);
            });
            document.querySelectorAll('code.hljs.linenumber').forEach((block) => {
                hljs.lineNumbersBlock(block);
            });
            // Remove loading animation
            document.querySelector('.loading-validator').classList.remove('d-block');
            // Go to validated result
            const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
            window.scroll({ top: targetPosition, behavior: 'smooth' });
        })
        .catch(error => {
            self.content("");
            self.error(error.message);
            self.showResult(true);
            // Remove loading animation
            document.querySelector('.loading-validator').classList.remove('d-block');
            // Go to validated result
            const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
            window.scroll({ top: targetPosition, behavior: 'smooth' });
        });
    };

    function diffUsingJS(baseXML, newXML) {
        "use strict";

        var base = difflib.stringAsLines(baseXML),
            newtxt = difflib.stringAsLines(newXML),
            sm = new difflib.SequenceMatcher(base, newtxt),
            opcodes = sm.get_opcodes(),
            diffoutputdiv = document.getElementById('webconfig_diff');

        diffoutputdiv.innerHTML = "";

        diffoutputdiv.appendChild(diffview.buildView({
            baseTextLines: base,
            newTextLines: newtxt,
            opcodes: opcodes,
            baseTextName: null,
            newTextName: null,
            contextSize: null,
            viewType: 1
        }));
    }

    function escapeHtml(unsafe) {
        return unsafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    self.input = ko.observable('<?xml version="1.0"?>\n<configuration>\n  <appSettings>\n    <add key="isProduction" value="false" />\n  </appSettings>\n  <system.web>\n    <compilation debug="true"/>\n  </system.web>\n</configuration>');
    self.input2 = ko.observable('<?xml version="1.0"?>\n<configuration xmlns:xdt="http://schemas.microsoft.com/XML-Document-Transform">\n  <appSettings>\n    <add key="isProduction" value="true" xdt:Transform="SetAttributes" xdt:Locator="Match(key)" />\n  </appSettings>\n  <system.web>\n    <compilation xdt:Transform="RemoveAttributes(debug)" />\n  </system.web>\n</configuration>');
    self.emptyInputs = ko.pureComputed(function(){
        return self.input() === "" && self.input2() === "";
    });
    self.showResult = ko.observable(false);
    self.content = ko.observable();
    self.webconfig = ko.observable();
    self.error = ko.observable();
    self.hasError = ko.pureComputed(function () {
        return self.error() && self.error().length > 0;
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
};


document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);

    document.querySelector("#webconfig").addEventListener('focus', (evt) => evt.target.select());
    document.querySelector("#transformation").addEventListener('focus', (evt) => evt.target.select());
});